import styled, { css } from "styled-components";
import { colors, device } from "../styles/stylesConfig";
import { useAnimations } from "../effects/Effects";
import { useLogEvent } from "../hooks/useLogEvent";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const MenuContainer = styled.div<{ show: string }>`
    width: 100%;
    height: 100vh;
    display: flex;
    color: white;
    align-items: center;
    flex-direction: column;
    justify-content: space-evenly;
    position: fixed;
    top: 0;
    left: 100%;
    z-index: 1;
    visibility: hidden;
    padding: 20vh 30px;

    @media ${device.lg} {
        visibility: visible;
    }

    @keyframes openModal {
        0% {
            left: 100%;
            background: rgba(0,0,0,0);
        }
        100% {
            left: 0%;
            background: rgba(0,0,0,0.9);
        }
    }

    @keyframes closeModal {
        0% {
            left: 0%;
            background: rgba(0,0,0,0.9);
        }
        100% {
            left: 100%;
            background: rgba(0,0,0,0);

        }
    }

    @keyframes closeText {
        0% {
            font-size: 28px;
            @media ${device.xs} {
                font-size: 20px;
            }
        }
        100% {
            font-size: 0px;
        }
    }

    ${({ show }) => show === 'false' && css`

        & > div {
            font-size: 0px;
            animation: closeText 0.2s normal;
            visibility: hidden;
        }
        display: none;
        animation: closeModal 0.3s normal;


    `}

    ${({ show }) => show === 'true' && css`
        display: flex;
        left: 0%;
        animation: openModal 0.3s normal;
        background: rgba(0,0,0,0.9);

    `}
`

const NavButton = styled.div`
    color: white;
    font-weight: 500;
    font-size: 20px;
    letter-spacing: 5px;
    padding: 10px 15px;
    border-radius: 5px;
    border-top: solid 1px transparent;
    border-bottom: solid 1px transparent;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: center;
    text-transform: uppercase;
    
    &:hover {
        color: ${colors.primary};

    }

    @media ${device.sm} {
        font-size: 16px;
    }

`

interface Props {
    showMenu: boolean;
    setShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
}

const MenuComponent = ({ showMenu, setShowMenu }: Props) => {

    const { t } = useTranslation();

    const {
        handleClickGoHome,
        handleClickGoServices,
        handleClickGoProducts,
        handleClickGoAbout,
    } = useAnimations()

    const { handleLogEvent } = useLogEvent();

    return (

        <MenuContainer show={showMenu.toString()}>

            <NavButton onClick={async () => {

                handleClickGoHome();

                handleLogEvent('click_boton_inicio_menu');

                setShowMenu(false);

            }}>
                {t('header.home')}
            </NavButton>

            <NavButton onClick={async () => {

                handleClickGoServices()

                handleLogEvent('click_boton_servicios_menu');

                setShowMenu(false);
            }}>
                {t('header.services')}
            </NavButton>

            <NavButton onClick={async () => {

                handleClickGoProducts()

                handleLogEvent('click_boton_productos_menu');

                setShowMenu(false);
            }}>
                {t('header.products')}
            </NavButton>

            <NavButton onClick={async () => {

                handleClickGoAbout();

                handleLogEvent('click_boton_nosotros_menu');

                setShowMenu(false);
            }}>
                {t('header.about')}
            </NavButton>

            <NavButton
                style={{ backgroundColor: colors.primary }}
                onClick={async (e: any) => {

                    let message = t('wsp.link.number') + t('wsp.link.message');

                    handleLogEvent('click_boton_contacto_menu');

                    e.target?.blur()

                    window.open(message, 'blank')

                }}>
                {t('header.contact')}
            </NavButton>

        </MenuContainer>

    )
}

const Menu = memo(MenuComponent);

export default Menu;